import * as actionTypes from "../../constants/ActionTypes/HardwareInclusive/HardwareInclusive";
import { getHardwareFeatureFlags } from "../../utils/HardwareInclusive/HardwareInclusive";

const initialState = {
    printerFeatures: {},
    loading: false,
    error: "",
    success: false,
    service_available_err: false,
    HW_featureSwitchData:{},
    hardwareFeatureFlags: { 
        isHWOnly: false,
        isNPBOnly: false,
        isBothEnabled: false
    }
}

const GetHWPrinterFeaturesByPrinterType = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_HW_PRINTER_FEATURE_BY_PRINTER_TYPE:
            return {
                ...state,
                loading: true,
                success: false,
                error: "",
                printerFeatures:{},
                service_available_err: false
            };
        case actionTypes.GET_HW_PRINTER_FEATURE_BY_PRINTER_TYPE_SUCCESS:
            return {
                ...state,
                printerFeatures: action.printerFeatures,
                loading: false,
                success: true,
                error: "",
                service_available_err: false
            };
        case actionTypes.GET_HW_PRINTER_FEATURE_BY_PRINTER_TYPE_ERROR:
            return {
                ...state,
                loading: false,
                error: action.message,
                success: false,
                printerFeatures:{},
                service_available_err: false
            };
        case actionTypes.HW_INCLUSIVE_SERVICE_AVAILABLE_STATUS_SUCCESS:
            const derivedFlags = getHardwareFeatureFlags(action.HW_featureSwitchData);
            return {
                ...state,
                loading: false,
                success:true,
                HW_featureSwitchData: action.HW_featureSwitchData,
                hardwareFeatureFlags: derivedFlags,
                service_available_err:false
            }
        case actionTypes.HW_INCLUSIVE_SERVICE_AVAILABLE_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: false,
                success: false,
                printerModel:{},
                service_available_err: true
            };
        case actionTypes.GET_HW_PRINTER_FEATURE_BY_PRINTER_TYPE_RESET:
            return {
                success: false,
                error: "",
                printerFeatures:{},
                service_available_err: false
            }
        default:
            return {...state};
    }
}

export default GetHWPrinterFeaturesByPrinterType;